// Who is signed in, and what their token says they may do.
//
// Split out of firebase-auth.js so that cloud-sync.js, media.js, arbiters.js and
// registrations-store.js can read the session without importing the module that
// OWNS it — which would be an import cycle. This module imports nothing.
//
// The three values are exported as `let` bindings and imported live, so every
// reader sees a reassignment made through the setters below the instant it
// happens. That is why the moved code still reads a bare `currentUser` exactly as
// it did when all of it was one file.
//
// firebase-auth.js is the ONLY writer: it is where onAuthStateChanged lands, and
// nothing else has any business deciding who is signed in.

export let currentUser = null;

// What the ID token says this account is allowed to be: `{ role, admin }`.
//
// These are CUSTOM CLAIMS, signed by Firebase and set only by the Admin SDK
// (accountApi when an access code is redeemed, adminApi when an administrator
// grants something). That is what makes them worth reading: the role stored on
// users/{uid} is writable by the account it belongs to, so it can describe the
// UI but must never decide access — and firestore.rules now agrees, gating
// tournament and database creation on the claim.
//
// Empty for an account that predates claims. Nothing here invents one; the
// backfill script does that, once, where it can be seen.
export let currentClaims = {};

// False until the first onAuthStateChanged report, however that report ends.
// Anything that must not act on "nobody is signed in" before the check has
// actually run waits on this.
export let isAuthInitialized = false;

export function setCurrentUser(user) {
    currentUser = user;
}

export function setCurrentClaims(claims) {
    currentClaims = claims;
}

export function markAuthInitialized() {
    isAuthInitialized = true;
}
